import { AbstractProperty } from "./AbstractProperty";
import { Node } from "../Node";
import { PropertyParameters } from "../../global";

export class PAny extends AbstractProperty<any, Node> {
  constructor(args: PropertyParameters) {
    super({
      type: "Any",
      ...args,
    });
  }

  typeCheck(value: any) {
    return true;
  }
}
